module.exports = __webpack_public_path__ + "static/media/12_after.df967677.jpg";